import { projectTreeItemTypeOptions } from '../../../../../../react-query/project/query/use-get-project-tree-query'

export const projectMenuDropTargetTypeOptions = {
  FOLDER: 'folder',
  ROW: 'row',
  ROOT: 'root',
  ROOT_ROW: 'rootRow'
}

export const flattenRows = (rows) =>
  rows.flatMap((row) => [row, ...flattenRows(row.subRows ?? [])])

export const getExpandedFolderIds = (expanded) => {
  if (!expanded || expanded === true) return []

  return Object.entries(expanded)
    .filter(([, isExpanded]) => isExpanded)
    .map(([folderId]) => folderId)
}

export const getMovePayload = (items) => {
  return items.reduce(
    (payload, item) => {
      if (item.type === projectTreeItemTypeOptions.FOLDER) {
        payload.folderIds.push(item.id)
      } else {
        payload.projectIds.push(item.id)
      }

      return payload
    },
    {
      folderIds: [],
      projectIds: []
    }
  )
}

export const canMoveItemToFolder = (item, destinationFolder) => {
  if (!item || !destinationFolder) return false
  if (item.parentId === destinationFolder.id) return false

  if (item.type !== projectTreeItemTypeOptions.FOLDER) return true

  return (
    item.id !== destinationFolder.id &&
    !destinationFolder.ancestorFolderIds.includes(item.id)
  )
}

export const canMoveItemToRoot = (item) =>
  !!item &&
  item.parentId !== null &&
  item.parentId !== undefined &&
  item.ancestorFolderIds?.length > 0

export const getActiveItem = (active, rowsById) =>
  active?.data.current?.item ?? rowsById.get(active?.id)

export const getItemsToMove = ({ activeItem, rowSelection, rowsById }) => {
  if (!activeItem) return []

  const selectedItems = Object.entries(rowSelection ?? {})
    .filter(([, isSelected]) => isSelected)
    .map(([rowId]) => rowsById.get(rowId))
    .filter(Boolean)

  return rowSelection?.[activeItem.id] ? selectedItems : [activeItem]
}

export const getMovableItemsToFolder = (items, destinationFolder) =>
  items.filter((item) => canMoveItemToFolder(item, destinationFolder))

export const getMovableItemsToRoot = (items) => items.filter(canMoveItemToRoot)

export const canDropItemsToFolder = (items, destinationFolder) =>
  getMovableItemsToFolder(items, destinationFolder).length > 0

export const canDropItemsToRoot = (items) =>
  getMovableItemsToRoot(items).length > 0

export const getExpandedWithFolder = (expanded, folderId) => {
  if (expanded === true || expanded?.[folderId]) return expanded

  return {
    ...expanded,
    [folderId]: true
  }
}
